<template>
    <div>
        <v-row>
            <v-col cols="12">
                <div class="headline">Straßen</div>
                <v-card>
                    <v-card-title>
                      <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.streets.header"
                            :items="streets"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Straßen vorhanden"
                            :items-per-page="15"
                    >
                      <template v-slot:item.city="{ item }">
                        {{ getCity(item.city).name }}
                      </template>
                      <template v-slot:item.district="{ item }">
                        {{ getDistrict(item.district).name }}
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn icon @click="editItem(item)">
                          <v-icon>far fa-edit</v-icon>
                        </v-btn>
                        <v-btn icon @click="deleteItem(item)">
                          <v-icon>far fa-trash</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                </v-card>
              <v-card-actions>
                <v-btn color="primary" dark class="mb-2" @click="editItem(defaultItem)">Neue Straße</v-btn>
              </v-card-actions>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline" v-if="isNewElement">Neue Straße</span>
                    <span class="headline" v-else>Straße bearbeiten</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                        :items="districts"
                                        item-text="cityAndDistrict"
                                        item-value="id"
                                        v-model="editedItem.district"
                                        label="Gemeinde"
                                        no-data-text="Keine Gemeinde vorhanden"
                                        :disabled="!isNewElement"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editedItem.name" label="Straße"></v-text-field>
                            </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.mapCoordinate" label="Kartenkoordinaten"></v-text-field>
                          </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="close">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="save">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'Streets',
  computed: {
    cities () {
      return this.$store.state.cities.all
    },
    districts () {
      return this.$store.state.districts.all
    },
    streets () {
      return this.$store.state.streets.all
    },
    duties () {
      return this.$store.state.duties.all
    },
    isNewElement () {
      return this.editedItem.id === 0
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: 0,
      city: 0,
      name: ''
    },
    defaultItem: {
      id: 0,
      city: 0,
      name: ''
    },
    search: '',
    tables: {
      streets: {
        header: [
          {text: 'Kartenabschnitt', value: 'mapCoordinate'},
          {text: 'Ort', value: 'city'},
          {text: 'Ortsteil', value: 'district'},
          {text: 'Straße', value: 'name'},
          {text: 'Aktionen', sortable: false, value: 'action'}
        ]
      }
    }
  }),
  methods: {
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    save () {
      if (this.isNewElement) {
        this.$store.commit('addStreet', this.editedItem)
      } else {
        this.$store.commit('updateStreet', this.editedItem)
      }
      this.close()
    },
    deleteItem (item) {
      if (confirm('Soll die Straße "' + item.name + '" wirklich gelöscht werden? ')) {
        this.$store.commit('delStreet', item)
      }
    },
    getCity (id) {
      return this.$store.state.cities.all.find(element => element.id === id)
    },
    getDistrict (id) {
      return this.$store.state.districts.all.find(element => element.id === id)
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/Streets.vue